export default {
	isIOS: state => state.platform === "ios"
};
